import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, Row, Select, Typography } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  enable: (cstIcmsParam: string[], csosnIcmsParam?: string[]) => boolean;
}

const IcmsFields: React.FC<Props> = ({ enable }) => {
  const intl = useIntl();
  const { Title } = Typography;

  const { purchaseReadOnly } = useReleasePurchaseFormContext();

  return (
    <Form.Item shouldUpdate noStyle>
      {() => {
        return (
          <>
            <Row gutter={[12, 12]}>
              <Col span={24} lg={24}>
                <Title level={3} style={{ padding: 0 }}>
                  {intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.icms',
                  })}
                </Title>
              </Col>

              <Col span={24} lg={8} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'modBcIcms']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms',
                  })}
                >
                  <Select
                    disabled={
                      !enable(['00', '10', '20', '70', '90'], ['900']) ||
                      purchaseReadOnly
                    }
                    allowClear
                    style={{ width: '100' }}
                    options={[
                      {
                        value: 0,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.zero',
                        }),
                      },
                      {
                        value: 1,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.one',
                        }),
                      },
                      {
                        value: 2,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.two',
                        }),
                      },
                      {
                        value: 3,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.three',
                        }),
                      },
                    ]}
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'reductionIcms']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.reductionIcms',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['20', '70', '90'], ['900']) || purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'baseIcms']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.baseIcms',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['00', '10', '20', '70', '90'], ['900']) ||
                      purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'quotaIcms']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.quotaIcms',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['00', '10', '20', '70', '90'], ['900']) ||
                      purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'valueIcms']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.valueIcms',
                  })}
                  initialValue={0}
                >
                  <InputDecimal
                    disabled={
                      !enable(['00', '10', '20', '70', '90'], ['900']) ||
                      purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'baseFcp']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.baseFcp',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['00', '10', '20', '51', '70', '90']) ||
                      purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'quotaFcp']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.quotaFcp',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['00', '10', '20', '51', '70', '90']) ||
                      purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'valueFcp']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.valueFcp',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['00', '10', '20', '51', '70', '90']) ||
                      purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'valueIcmsUnencumbered']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.valueIcmsUnencumbered',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['20', '30', '40', '41', '50', '70', '90']) ||
                      purchaseReadOnly
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={24} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'motDesIcms']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms',
                  })}
                >
                  <Select
                    disabled={
                      !enable(['20', '30', '40', '41', '50', '70', '90']) ||
                      purchaseReadOnly
                    }
                    allowClear
                    style={{ width: '100' }}
                    options={[
                      {
                        value: 1,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.one',
                        }),
                      },
                      {
                        value: 3,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.three',
                        }),
                      },
                      {
                        value: 4,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.four',
                        }),
                      },
                      {
                        value: 5,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.five',
                        }),
                      },
                      {
                        value: 6,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.six',
                        }),
                      },
                      {
                        value: 7,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.seven',
                        }),
                      },
                      {
                        value: 8,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.eigth',
                        }),
                      },
                      {
                        value: 9,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.nine',
                        }),
                      },
                      {
                        value: 10,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.ten',
                        }),
                      },
                      {
                        value: 11,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.eleven',
                        }),
                      },
                      {
                        value: 12,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.twelven',
                        }),
                      },
                    ]}
                  />
                </FloatingFormItem>
              </Col>
            </Row>
          </>
        );
      }}
    </Form.Item>
  );
};

export default IcmsFields;
